import React from "react";
import "../styles/TablesSTopBar.css";
import { useGame } from "../GameContext";
const TopBar: React.FC = () => {
  const { message, setHelpPanelOpen } = useGame();
  return (
      <div className="tableS-top-bar">
        <a className="tableS-logo" href="https://kotobot.app/index.html">
          <img
            className="tableS-logo"
               title ="На главную"
            src="/img/kotobot.svg"
            alt="Kotobot logo"
          />
        </a>
        <div className="tableS-message-bar">{message}</div>
        <img
          className="tableS-icon"
          id = "tableS-help-icon"
          alt="Помощь"
          src="/img/help-fix.svg"
          title="Помощь"
          onClick={() => setHelpPanelOpen(true)}
        />
      </div>
  );
};

export default TopBar;
